import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 8l-3-3-3 3h6zm-.1 4L10 14.9 7.1 12h5.8z",
  fillRule: "evenodd"
});

var SvgSelectMinor = function SvgSelectMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgSelectMinor as S };
